import React, { useState, useEffect } from "react";

import { Toaster, ListBoxModal } from "components";

import { func_validation } from "functions";

export function useUserGroupMapping(props) {
    const {
        userList, userGroupList,
        totalRequests,
        userLabels,
        getUserList_requesting,
        addUserGroupMapping_requesting,
        removeUserGroupMapping_requesting,
        isUserRecordUpdatedSuccessfully
    } = props;

    const [selectedUserDetail, setSelectedUserDetail] = useState({});
    const [selectedUserIndexList, setSelectedUserIndexList] = useState();
    const [isRemovingUserGroup_requesting, setIsRemovingUserGroup_requesting] = useState();
    const [isModalVisible_user, setIsModalVisible_user] = useState(false);

    function handleUserGroupMappingUpdate(selectedValues) {
        // Username is required
        if (func_validation.isObjectEmpty(selectedUserDetail)) return;
        let userGroupID = func_validation.getObjectPropertyValue(selectedUserDetail, "ID");

        // convert to object for faster traversing
        let selectedValueObj = {}
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userDetails, idx) => {
                let username = func_validation.getObjectPropertyValue(userDetails, "UserName");
                selectedValueObj[username] = true;
            })
        }
        let selectedUserListObj = {};
        if (func_validation.isArrayNotEmpty(selectedUserIndexList) &&
            func_validation.isArrayNotEmpty(userList)) {
            selectedUserIndexList.map((userIndex, idx) => {
                let obj = userList[userIndex];
                let username = func_validation.getObjectPropertyValue(obj, "UserName");
                selectedUserListObj[username] = true;
            })
        }

        // Deletion
        let deletedList = [];
        if (func_validation.isArrayNotEmpty(selectedUserIndexList)) {
            selectedUserIndexList.map((userIndex, index) => {
                let obj = userList[userIndex];
                let username = func_validation.getObjectPropertyValue(obj, "UserName");

                if (!selectedValueObj.hasOwnProperty(username)) {

                    // Find the user group mapping username for the selected user group username
                    let userGroupMappings = func_validation.getObjectPropertyValue(obj, "UserGroupMappings");
                    if (func_validation.isArrayNotEmpty(userGroupMappings)) {
                        for (let i = 0; i < userGroupMappings.length; i++) {
                            let userGroupMapping = userGroupMappings[i];
                            let userGroupID_searching = func_validation.getObjectPropertyValue(userGroupMapping, "UserGroupId");
                            let userGroupMappingID = func_validation.getObjectPropertyValue(userGroupMapping, "ID");

                            if (userGroupID == userGroupID_searching &&
                                userGroupMappingID) {

                                deletedList.push(userGroupMappingID);
                                break;
                            }
                        }
                    }
                }
            });

            if (props.removeUserGroupMapping &&
                func_validation.isArrayNotEmpty(deletedList)) {

                if (true || func_validation.isUserAccessGranted(props, "Dealer_UserGroupMapping_Delete")) {
                    deletedList.map((id) => {
                        props.removeUserGroupMapping(id);
                    })
                }
                else {
                    Toaster({ 
                        type: "error",
                        msg: "No permission granted to delete user group mapping"
                    });
                }
            }
        }

        // Addition
        let addedList = [];
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userDetails) => {
                let username = func_validation.getObjectPropertyValue(userDetails, "UserName");

                if (!selectedUserListObj.hasOwnProperty(username) &&
                    func_validation.isStringTrimNotEmpty(username)) {
                    let obj = {};
                    obj["ID"] = 0;
                    obj["UserName"] = username;
                    obj["UserGroupId"] = userGroupID;

                    addedList.push(obj);
                }
            });

            if (props.addUserGroupMapping &&
                func_validation.isArrayNotEmpty(addedList)) {

                if (true || func_validation.isUserAccessGranted(props, "Dealer_UserGroupMapping_Add")) {
                    props.addUserGroupMapping(addedList);
                }
                else {
                    Toaster({ 
                        type: "error",
                        msg: "No permission granted to add user group mapping"
                    });
                }
            }      
        }
    }

    useEffect(() => {
        if (props.getList)
            props.getList();
    }, [userGroupList]);

    let userGroupMappingModal = (
        <ListBoxModal
            isModalVisible={isModalVisible_user}
            updateParentState={setIsModalVisible_user}

            title={"Users"}

            header={"List"}

            initSelectedIndexes={selectedUserIndexList}
            list={userList}
            labelList={userLabels}
            isListLoading={getUserList_requesting}

            actionTxt={"Save"}
            handleOnConfirm={(list) => { 
                handleUserGroupMappingUpdate(list); 
                setIsRemovingUserGroup_requesting(true); 
            }}
            isActionLoading={addUserGroupMapping_requesting || removeUserGroupMapping_requesting}
            isClosedOnSuccess={isUserRecordUpdatedSuccessfully}

            isDisabled={false && func_validation.isUserAccessDenied(props, "Dealer_UserGroupMapping_Add") &&
                false && func_validation.isUserAccessDenied(props, "Dealer_UserGroupMapping_Delete")}
        />
    )

    useEffect(() => {
        if (totalRequests <= 0)
            setIsRemovingUserGroup_requesting(false);
    }, [totalRequests]);

    return {
        setSelectedUserDetail,
        handleUserGroupMappingUpdate,
        selectedUserIndexList, setSelectedUserIndexList,
        userGroupMappingModal, setIsModalVisible_user
    }
}